import { render, staticRenderFns } from "./LabelForm.vue?vue&type=template&id=71b1d46d&scoped=true&"
import script from "./LabelForm.vue?vue&type=script&lang=ts&"
export * from "./LabelForm.vue?vue&type=script&lang=ts&"
import style0 from "./LabelForm.vue?vue&type=style&index=0&id=71b1d46d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b1d46d",
  null
  
)

export default component.exports